export default {
    state: {
        attachments: [],
        attachmentsNextUrl: undefined,
    },
    mutations: {
        ADD_ATTACHMENTS(state, payload) {
            state.attachments.push(...payload.data);
            state.attachmentsNextUrl = payload.next;
        },
        SET_ATTACHMENTS(state, payload) {
            state.attachments = payload.data;
            state.attachmentsNextUrl = payload.next;
        },
    },
    actions: {
        getAttachments({ state, commit }, payload) {
            const next = state.attachmentsNextUrl;
            if (next || next === undefined || payload.initialLoad) {
                const url = payload.initialLoad || !next ? "/attachments" : next;
                let params = { ...payload.data };

                return window.axios.get(url, { params }).then((response) => {
                    let data = {
                        data: response.data.data,
                        // next: response.data?.links.next,
                    };
                    if (payload.initialLoad) {
                        commit("SET_ATTACHMENTS", data);
                    } else {
                        commit("ADD_ATTACHMENTS", data);
                    }
                });
            }
        },
    },
};
